var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.934 1.875H7.83c-.447 0-.745.3-.745.9v4.5H2.62c-.446 0-.744.3-.744.6v13.35c0 .45.298.9.893.9h13.103c.447 0 .894-.45.894-.9v-4.5h4.467c.446 0 .893-.3.893-.9V2.775c-.298-.6-.744-.9-1.191-.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesActive);
export default __webpack_public_path__ + "static/media/pages_active.c9f2f108863d609f4ae43bd9447da7a8.svg";
export { ForwardRef as ReactComponent };